<div class="success-message" *ngIf="successMessage" style="margin-bottom: 1rem; {{ style }}">
  <mat-icon>check_circle</mat-icon>
  <p>{{ successMessage }}</p>
</div>

<div class="error-message" *ngIf="errorMessage" style="margin-bottom: 1rem; {{ style }}">
  <mat-icon>error</mat-icon>
  <p>{{ errorMessage }}</p>
</div>
